import { Pipe, PipeTransform } from "@angular/core";
import { ApplicationConfiguration } from "@rx/core"
@Pipe({ name: 'valueOf' })
export class ValueOfPipe implements PipeTransform {
    format: string;
    seperator: string;
    constructor() {
        var date = ApplicationConfiguration.get('internationalization.date');
        this.format = date.format;
        this.seperator = date.seperator;
    }
    transform(row: any, filed: string, dataType: string): any {
        if (dataType === "date" && row[filed]) {
            var date = this.makeDateString(row[filed]);
            return date;
        }
        return row[filed];
    }

    makeDateString(value: string): string {
        let dateString: string = '';
        let dateValue: Date = new Date(value);
        if (dateValue.toString() == 'Invalid Date') {
            dateString = value;
        }
        else {
            for (let character of this.format) {
                switch (character) {
                    case 'm':
                        dateString += dateString.length == 0 ? (dateValue.getMonth() + 1).toString() : this.seperator + (dateValue.getMonth() + 1)
                        break;
                    case 'd':
                        dateString += dateString.length == 0 ? (dateValue.getDate()).toString() : this.seperator + (dateValue.getDate())
                        break;
                    case 'y':
                        dateString += dateString.length == 0 ? (dateValue.getFullYear()).toString() : this.seperator + (dateValue.getFullYear())
                        break;
                }
            }
        }
        return dateString;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/table/pipes/value-of.pipe.ts